import React, { useState } from 'react'
import EditIcon from '@mui/icons-material/Edit'
import { Button, Card, Divider, Grid, Typography } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import CallIcon from '@mui/icons-material/Call'
import EmailIcon from '@mui/icons-material/Email'
import LocationOnIcon from '@mui/icons-material/LocationOn'

import { PropertyList } from '../../../../../../../components/PropertyList'
import { PropertyListItem } from '../../../../../../../components/PropertyListItem'
import CircularLoading from '../../../../../../../components/CircularProgress'
import { ILead, ILeadCustomer } from '../../../../../../../types/lead'
import { LeadEditAddressModal } from './LeadEditAddressModal'

interface FilterGroupProps {
  isLoading: boolean
  data?: ILead
  onUpdateLeadSuccess: () => void
  isFinished?: boolean
}

const LeadAddressDetailCard = ({
  isLoading,
  data,
  onUpdateLeadSuccess,
  isFinished,
}: FilterGroupProps) => {
  const [isOpenedOrderDrawer, setIsOpenedOrderDrawer] = useState<boolean>(false)
  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <LeadEditAddressModal
        isOpen={isOpenedOrderDrawer}
        onClose={() => setIsOpenedOrderDrawer(false)}
        address={data?.customer}
        objectId={data?.objectId}
        onUpdateAddressListSuccess={onUpdateLeadSuccess}
      />
      <Card sx={{ padding: 2 }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            lg={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h6" color="text.secondary">
              ข้อมูลผู้ติดต่อ/ ลูกค้า
            </Typography>
            {data?.cancelAt === null && !isFinished && (
              <Button
                startIcon={<EditIcon />}
                onClick={() => setIsOpenedOrderDrawer(true)}
              >
                แก้ไขข้อมูลลูกค้า
              </Button>
            )}
          </Grid>
          <Grid item xs={12} lg={12}>
            <PropertyList>
              <PropertyListItem
                minWidth={40}
                align={`horizontal`}
                label={<PersonIcon sx={{ color: '#bbb' }} />}
                value={data?.customer?.name}
              />
              <Divider />
              <PropertyListItem
                minWidth={40}
                align={`horizontal`}
                label={<CallIcon sx={{ color: '#bbb' }} />}
                value={data?.customer?.phone}
              />
              <Divider />
              <PropertyListItem
                minWidth={40}
                align={`horizontal`}
                label={<EmailIcon sx={{ color: '#bbb' }} />}
                value={data?.customer?.email || '-'}
              />
              <Divider />
              <PropertyListItem
                minWidth={40}
                align={`horizontal`}
                label={<LocationOnIcon sx={{ color: '#bbb' }} />}
                value={`${data?.customer?.address ?? ''} ${
                  data?.customer?.subDistrict ?? ''
                } ${data?.customer?.district ?? ''} ${
                  data?.customer?.province ?? ''
                } ${data?.customer?.zipcode ?? ''}`}
              />
              <Divider />
            </PropertyList>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

export default LeadAddressDetailCard
